<template>
  <div class="Addperson addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <el-button @click="submit" type="primary" class="searchBtn" :loading="loadingSave" style="margin-bottom: 16px;">{{$t('LanguageLib.SAVE')}}</el-button>
      <div class="TreeBox">
        <div style="">
          <el-button style="padding: 0 0 16px 0;margin-left: 0;" type="text" :title="showStatusTitle" @click="unFoldAll" v-show="(showStatusTitle === $t('LanguageLib.EXPAND'))">{{showStatusTitle}}</el-button>
          <el-button style="padding: 0 0 16px 0;margin-left: 0;" type="text" :title="showStatusTitle" @click="collapseAll" v-show="(showStatusTitle !== $t('LanguageLib.EXPAND'))">{{showStatusTitle}}</el-button>
        </div>
        <el-collapse v-model="AllActiveNames">
          <el-checkbox style="float: left;height: 48px;line-height: 48px;margin-right: 10px;" :indeterminate="isIndeterminate" @change="value =>{DataCheck(value)}" v-model="checkAll"></el-checkbox>
          <span class="collapseHeaderTitle">{{$t('LanguageLib.ALL_AUTHORITY')}}</span>
          <el-collapse-item name="-1">
            <el-collapse v-model="ActiveNames" style="padding-left: 24px" v-for="(item, index) in authorityList" :key="index">
              <el-checkbox style="float: left;height: 48px;line-height: 48px;margin-right: 10px;" :indeterminate="item['indeterminate' + index]" @change="value =>{ItemModuleDataCheck(value, item)}" v-model="item.isAllChecked"></el-checkbox>
              <span class="collapseHeaderTitle">{{item.moduleName}}({{item.checkNum}}/{{item.allNum}})</span>
              <el-collapse-item :name="index + ''" style="padding-left: 24px">
                <div style="display: flex;flex-wrap: wrap;">
                  <div class="resitem" v-for="(resitem, index) in item.resourceList" :key="index">
                     <el-checkbox style="float: left;margin-right: 10px;" v-model="resitem.isChecked" @change="ItemDataCheck(item)"></el-checkbox>
                     <el-popover
                      placement="bottom"
                      :title="resitem.resourceName"
                      width="200"
                      trigger="hover"
                      :content="resitem.remark">
                      <span slot="reference" class="collapseHeaderItem">{{resitem.resourceName}}</span>
                    </el-popover>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  name: 'UpdateRoleAuthority',
  data () {
    return {
      showStatusTitle: this.$t('LanguageLib.COLLAPSE'),
      isIndeterminate: false,
      checkAll: false,
      AllActiveNames: ['-1'],
      ActiveNames: [],
      loadingSave: false,
      defaultProps: {
        children: 'resourceList',
        label: 'resourceName'
      },
      authorityList: null, // 权限列表
      titleType: this.$commonfun.StrReplace(this.$t('LanguageLib.UPDATE_ROLE_AUTHORITY_TITLE'), JSON.parse(this.$commonfun.decodeUrl(this.$route.query.data)).roleName)
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    // 获取组织类型列表
    var id = JSON.parse(decodeURIComponent(to.query.data)).id
    basicdataApi.GetRolesAuthorityList('get', '/role/resource/list', {
      roleId: id
    })
      .then(res => {
        NProgress.done()
        next(vm => {
          vm.authorityList = res.data
          for (var i in res.data) {
            var indeterminate = 'indeterminate' + i
            var checkNum = 0
            for (var k in res.data[i].resourceList) {
              if (res.data[i].resourceList[k].isChecked) {
                checkNum++
              }
            }
            if (checkNum > 0) {
              vm.authorityList[i][indeterminate] = true
            } else {
              vm.authorityList[i][indeterminate] = false
            }
            vm.authorityList[i].allNum = res.data[i].resourceList.length
            vm.authorityList[i].checkNum = checkNum
            vm.authorityList[i].index = i
            vm.ActiveNames.push(i + '')
            if (vm.authorityList[i].checkNum === vm.authorityList[i].allNum) {
              vm.authorityList[i].isAllChecked = true
              vm.authorityList[i][indeterminate] = false
            } else {
              vm.authorityList[i].isAllChecked = false
            }
          }
          var allCheckedNum = 0
          for (var x in vm.authorityList) {
            if (vm.authorityList[x].checkNum > 0) {
              vm.isIndeterminate = true
            }
            if (vm.authorityList[x].isAllChecked) {
              allCheckedNum++
            }
          }
          if (allCheckedNum === vm.authorityList.length) {
            vm.checkAll = true
            vm.isIndeterminate = false
          } else {
            vm.checkAll = false
          }
        })
      })
      .catch(err => {
        console.log(err)
      })
  },
  created () {
  },
  methods: {
    // 所有权限勾选
    DataCheck (value) {
      this.isIndeterminate = false
      // 去除半选状态
      for (var i in this.authorityList) {
        if (value) {
          this.authorityList[i].isAllChecked = true
          this.authorityList[i]['indeterminate' + i] = false
          this.authorityList[i].checkNum = this.authorityList[i].allNum
        } else {
          this.authorityList[i].isAllChecked = false
          this.authorityList[i]['indeterminate' + i] = false
          this.authorityList[i].checkNum = 0
        }
        for (var k in this.authorityList[i].resourceList) {
          if (value) {
            this.authorityList[i].resourceList[k].isChecked = true
          } else {
            this.authorityList[i].resourceList[k].isChecked = false
          }
        }
      }
    },
    // 单个模块权限勾选
    ItemModuleDataCheck (value, data) {
      data['indeterminate' + data.index] = false
      var allCheckedNum = 0
      var allishascheck = false
      if (value) {
        data.checkNum = data.allNum
      } else {
        data.checkNum = 0
      }
      for (var i in data.resourceList) {
        if (value) {
          data.resourceList[i].isChecked = true
        } else {
          data.resourceList[i].isChecked = false
        }
      }
      for (var k in this.authorityList) {
        if (value) {
          if (this.authorityList[k]['indeterminate' + k] || this.authorityList[k].isAllChecked) {
            allishascheck = true
          }
          if (this.authorityList[k].isAllChecked) {
            allCheckedNum++
          }
        } else {
          if (this.authorityList[k]['indeterminate' + k] || this.authorityList[k].isAllChecked) {
            allishascheck = true
          }
          if (this.authorityList[k].isAllChecked) {
            allCheckedNum++
          }
        }
      }
      this.isIndeterminate = allishascheck
      if (allCheckedNum === this.authorityList.length) {
        this.checkAll = true
        this.isIndeterminate = false
      } else {
        this.checkAll = false
      }
    },
    // 单个权限勾选
    ItemDataCheck (value) {
      var ishascheck = false
      var index = value.index
      var checkNum = 0
      var allCheckedNum = 0
      for (var i in value.resourceList) {
        if (value.resourceList[i].isChecked) {
          ishascheck = true
          checkNum++
        }
      }
      value['indeterminate' + index] = ishascheck
      value.checkNum = checkNum
      if (value.checkNum === value.allNum) {
        value.isAllChecked = true
        value['indeterminate' + index] = false
      } else {
        value.isAllChecked = false
      }
      var allishascheck = false
      for (var k in this.authorityList) {
        if (this.authorityList[k]['indeterminate' + k] || this.authorityList[k].isAllChecked) {
          allishascheck = true
        }
        if (this.authorityList[k].isAllChecked) {
          allCheckedNum++
        }
      }
      this.isIndeterminate = allishascheck
      if (allCheckedNum === this.authorityList.length) {
        this.checkAll = true
        this.isIndeterminate = false
      } else {
        this.checkAll = false
      }
    },
    // 展开
    unFoldAll () {
      this.showStatusTitle = this.$t('LanguageLib.COLLAPSE')
      this.AllActiveNames = ['-1']
      for (var i in this.authorityList) {
        this.ActiveNames.push(i + '')
      }
    },
    // 收起
    collapseAll () {
      this.showStatusTitle = this.$t('LanguageLib.EXPAND')
      this.AllActiveNames = []
      this.ActiveNames = []
    },
    // 返回
    goReturn () {
      this.$router.push('/basicdata/rolesetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&sort=' + this.$route.query.sort + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&IsAsc=' + this.$route.query.IsAsc + '&fromPath=updateroleauthority')
    },
    // 保存数据
    submit () {
      var authIndexList = []
      for (var i in this.authorityList) {
        for (var k in this.authorityList[i].resourceList) {
          if (this.authorityList[i].resourceList[k].isChecked) {
            authIndexList.push({
              authIndex: this.authorityList[i].resourceList[k].authIndex,
              isBitMapMnt: this.authorityList[i].resourceList[k].isBitMapMnt
            })
          }
        }
      }
      var data = {
        roleId: JSON.parse(decodeURIComponent(this.$route.query.data)).id,
        authIndexList: authIndexList
      }
      basicdataApi.AddPerson('post', '/role/changeResource', data)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.SAVED_SUCCESSFULLY')
          })
          this.$router.push('/basicdata/rolesetting?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&sort=' + this.$route.query.sort + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&IsAsc=' + this.$route.query.IsAsc + '&fromPath=updateroleauthority')
          this.loadingSave = false
        })
        .catch(err => {
          this.loadingSave = false
          this.$commonfun.console.log(err)
        })
    }
  }
}
</script>

<style lang="scss">
  .Addperson {
    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }
    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;
      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }
      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }
      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }
    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }
    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc( 100% - 66px);
      overflow-y: auto;
      padding: 0 100px;
      padding-top: 15px;
      padding-bottom: 30px;
      box-sizing: border-box;
      .drawerText {
        margin-bottom: 5px;
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(77, 77, 77, 1);
        line-height: 16px;
      }
      h4 {
        font-size: 16px;
        color: #000;
        font-weight: normal;
        padding-top: 8px;
      }
      .contentTop{
        padding: 15px 0 24px 20px;
        .el-checkbox{
          margin-right: 30px;
        }
      }
      .infoForm {
        padding: 15px 0 0 20px;
        .parent {
          width: 50%;
          display: inline-block;
        }
      }
      .TreeBox::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }
      .TreeBox::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
        background: #E1E1E1;
      }
      .TreeBox::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
        border-radius: 5px;
        background: #fff;
      }
      .TreeBox{
        height: calc(100% - 48px);
        background: #FFFFFF;
        border: 1px solid #E1E1E1;
        padding: 16px 10px;
        box-sizing: border-box;
        overflow-y: auto;
        .collapseHeaderTitle{
          line-height: 48px;
          float: left;
          font-weight: 600;
          color: #606266;
          font-size: 14px;
        }
        .collapseHeaderItem{
          font-size: 14px;
          font-weight: 400;
          color: #606266;
          width: 200px;
          white-space: nowrap;
          display: block;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
        }
        .resitem{
          width: 230px;
          margin-bottom: 20px;
          margin-right: 10px;
        }
        .el-collapse-item__content{
          padding-bottom: 0px;
        }
      }
    }
     /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
      margin-left: 0;
    }
    .colorRed {
      color: red;
    }
    .el-textarea__inner {
      font: 400 13.3333px Arial;
    }
  }
.el-range-editor.el-input__inner{
  width: 320px;
}
.el-textarea{
  textarea{
    height: 124px;
  }
}
</style>
